import React from "react"
import autobind from "class-autobind"
import Clear from "../../../components/misc/Clear"
import strings from "../../../localization/strings"
import UserDetailsFaceSpaceTile from "./UserDetailsFaceSpaceTile"
import FaceSpaceListActionBar from "./FaceSpaceListActionBar"
import { IUserDocument, IFaceSpace } from "../../../models"
import AppStateStore from "../../../stores/AppStateStore"
import * as permissionHelper from "../../../helpers/permissionHelper"
import AuthenticationStore from "../../../stores/AuthenticationStore"

interface IProps {
    user: IUserDocument
    onDeleteFaceSpaces(faceSpaceIds: string[]): void
    onUpdateProfilePic(userId: string, faceSpace: IFaceSpace): void
}
interface IState {
    faceSpaces: IFaceSpace[]
    selectedFaceSpaces: IFaceSpace[]
}

export default class UserDetailsFaceSpaces extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            faceSpaces: props.user ? props.user.FaceSpaces : [],
            selectedFaceSpaces: []
        }
        autobind(this)
    }

    componentWillReceiveProps(nextProps: IProps) {
        this.setState({
            faceSpaces: nextProps.user ? nextProps.user.FaceSpaces : [],
            selectedFaceSpaces: this.state.faceSpaces.length !== nextProps.user.FaceSpaces.length ? [] : this.state.selectedFaceSpaces
        })
    }

    render() {
        return (
            <div className="user-details-face-spaces UserDetailsFaceSpaces">
                {permissionHelper.hasPermission(AuthenticationStore.Permissions.Employees.EditFaceSpaces) &&
                    this.state.faceSpaces && this.state.faceSpaces.length > 0 &&
                    <div>
                        <FaceSpaceListActionBar
                            selectionCount={this.state.selectedFaceSpaces.length}
                            allSelected={this.state.faceSpaces.length > 0 && this.state.faceSpaces.length === this.state.selectedFaceSpaces.length}
                            toggleAllSelect={() =>
                                this.setState({
                                    selectedFaceSpaces: this.state.faceSpaces.length === this.state.selectedFaceSpaces.length ? [] : this.state.faceSpaces
                                })
                            }
                            onDeleteSelected={() =>
                                AppStateStore.setConfirmDialogContent({
                                    title: strings.DELETE_SELECTED_FACE_SPACES,
                                    content: strings.Are_you_sure_delete_face_spaces,
                                    payload: this.state.selectedFaceSpaces.map(i => i.Id),
                                    confirm: (action, payload) => this.props.onDeleteFaceSpaces(payload)
                                })
                            }
                        />
                    </div>
                }
                <div className="detail-tab">
                    <div style={{ float: "left" }}>
                        <h2>{strings.formatString(strings.x_Records, this.state.faceSpaces ? this.state.faceSpaces.length : 0)}</h2>
                    </div>
                    <Clear />
                    <div>
                        {this.state.faceSpaces &&
                            this.state.faceSpaces.map((faceSpace, index) => {
                                const selectedIndexOf = this.state.selectedFaceSpaces.findIndex(i => i.Id === faceSpace.Id)
                                return (
                                    <div style={{ float: "left", margin: 10 }} key={index}>
                                        <UserDetailsFaceSpaceTile
                                            faceSpace={faceSpace}
                                            selected={selectedIndexOf > -1}
                                            onSelectedStateChange={() => {
                                                const selectedFaceSpaces = this.state.selectedFaceSpaces
                                                selectedIndexOf > - 1 ?
                                                    selectedFaceSpaces.splice(selectedIndexOf, 1) :
                                                    selectedFaceSpaces.push(faceSpace)
                                                this.setState({ selectedFaceSpaces })
                                            }}
                                            onDelete={() =>
                                                AppStateStore.setConfirmDialogContent({
                                                    title: strings.DELETE_FACESPACE,
                                                    content: strings.Are_you_sure_you_want_to_delete_this_Face_Space,
                                                    payload: [faceSpace.Id],
                                                    confirm: (action, payload) => this.props.onDeleteFaceSpaces(payload)
                                                })
                                            }
                                            onSetProfilePic={() =>
                                                AppStateStore.setConfirmDialogContent({
                                                    title: strings.UPDATE_PROFILE_IMAGE,
                                                    content: strings.Are_you_sure_replace_profile_image,
                                                    confirm: () => this.props.onUpdateProfilePic(this.props.user.Id, faceSpace)
                                                })
                                            }
                                        />
                                    </div>
                                )
                            })
                        }
                        <Clear />
                    </div>
                </div>
            </div>
        )
    }
}
